export const Logo = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <rect width="40" height="40" rx="8" fill="#0F172A" />
    <path d="M12 28V12L20 20L28 12V28" stroke="url(#logo-grad)" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="20" cy="12" r="2.5" fill="#E53E3E" />
    <defs>
      <linearGradient id="logo-grad" x1="12" y1="12" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00F0FF" />
        <stop offset="1" stopColor="#F8F9FA" />
      </linearGradient>
    </defs>
  </svg>
);

export default Logo;
